"use client";

import { Heading } from "@pamperedchef/design-system";
import { useConsultantStore } from "@/app/store/consultant/consultant-store";
import type { BlockOf } from "@/domain/catalog";
import { RecipePairingsCard } from "@/composites/product/RecipePairingsCard";
import type { NormalizedRecipe } from "../../helpers/recipe-pairings/normalized-recipe";
import * as styles from "./RecipePairings.module.scss";

export interface RecipePairingsProps {
	block: BlockOf<"recipe_pairings_block">;
	recipes?: NormalizedRecipe[];
}

export function RecipePairings({ block, recipes = [] }: RecipePairingsProps) {
	const consultantStatus = useConsultantStore(
		(s) => s.consultantState.status
	);
	const visible =
		consultantStatus === "connected"
			? recipes
			: recipes.filter((r) => !r.consultantOnly);

	if (visible.length === 0) return null;

	return (
		<section
			className={styles["section"]}
			data-block="recipe_pairings_block"
		>
			<Heading tag="h2" className={styles["headline"]}>
				{block.headline && block.headline.length > 0
					? block.headline
					: "Perfect for These Recipes"}
			</Heading>
			<div className={styles["grid"]}>
				{visible.map((recipe) => (
					<RecipePairingsCard key={recipe.refId} recipe={recipe} />
				))}
			</div>
		</section>
	);
}
